// extracted by mini-css-extract-plugin
export default {"container":"VerticalFlexContainer_container__jOKbo"};